import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import { CulturalOuting } from '../../lib/types/models/center/center-cultural-outing'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getCulturalOutings(query: PaginationRequest = {}) {
  return restApiClient
    .url(encodeNestedObject(API.culturalOutings.getAll.url, query))
    .get<PaginationResponse<CulturalOuting>>()
}
